import type { Kmat, SubstepTile } from "~/Configurators/Linear/models";
import { CSTIC_VALUE_WILDCARD_IS_NOT_SET, CSTIC_VALUE_WILDCARD_IS_SET } from "~/Configurators/Linear/constants";
import { getKmatType } from "~/Configurators/Linear/getKmatType";

export const isTileEnabled = (tile: SubstepTile, kmatsMap: Dict<Kmat[]>): boolean => {
  if (tile.isDisabledExternally) {
    return false;
  }
  return Object.entries(tile.csticsToEnable).every(([csticName, value]) => {
    const kmatType = getKmatType(csticName);
    const kmats = kmatsMap[kmatType];
    return kmats.every((kmat) => {
      const cstics = kmat.cstics;
      switch (value) {
        case CSTIC_VALUE_WILDCARD_IS_SET:
          return cstics[csticName] && cstics[csticName].value;
        case CSTIC_VALUE_WILDCARD_IS_NOT_SET:
          return cstics[csticName] && !cstics[csticName].value;
        default:
          return cstics[csticName] && cstics[csticName].values.some((csticVal) => csticVal.key === value);
      }
    });
  });
};
export const isTileStandard = (tile: SubstepTile, kmatsMap: Dict<Kmat[]>): boolean => {
  return Object.entries(tile.cstics).every(([csticName, value]) => {
    const kmatType = getKmatType(csticName);
    const kmats = kmatsMap[kmatType];
    if (!kmats) {
      return false;
    }
    return kmats.every((kmat) => {
      const cstics = kmat.cstics;
      const cstic = cstics[csticName];
      if (!cstic) {
        return false;
      }
      const csticValue = cstics[csticName].values.filter((val) => val.value === value)[0];
      if (!csticValue) {
        return false;
      }
      return csticValue.standard;
    });
  });
};
